import { createContext, useContext } from "react";
import type { IGlobalDragNDropContext } from "./types";

export const globalDragNDropContext = createContext<IGlobalDragNDropContext>({
  registerEvent: (event) => event,
  registerDragStart: (callback) => callback,
  registerDragUpdate: (callback) => callback,
  registerDragEnd: (callback) => callback,
  unregisterEvent: () => undefined,
  unregisterDragStart: () => undefined,
  unregisterDragUpdate: () => undefined,
  unregisterDragEnd: () => undefined,
});

export const useGlobalDragNDropContext = () => useContext(globalDragNDropContext);
